"use client";

import { c as _c } from "react/compiler-runtime";
import { tv } from "tailwind-variants";
import { ArrowUp } from "../../icons";
import { classNames } from "../../utils/classNames";
import { AnimatedNumber } from "../AnimatedNumber";
import { FlexCenter } from "../FlexCenter";
import { NumberDisplay } from "../NumberDisplay";
const statChangeVariants = tv({
  base: "font-mono",
  variants: {
    variant: {
      zero: "",
      // TODO: fix when colors improvements changes are made
      positive: "text-success-1",
      negative: "text-error-1"
    }
  }
});
export function StatChange(t0) {
  const $ = _c(17);
  let animated;
  let change;
  let className;
  let rest;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      animated,
      change,
      showPositiveSign: t1,
      display: t2,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = animated;
    $[2] = change;
    $[3] = className;
    $[4] = rest;
    $[5] = t1;
    $[6] = t2;
  } else {
    animated = $[1];
    change = $[2];
    className = $[3];
    rest = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  const showPositiveSign = t1 === undefined ? true : t1;
  const display = t2 === undefined ? "percent" : t2;
  const Comp = animated ? AnimatedNumber : NumberDisplay;
  const positive = typeof change === "number" && change > 0;
  const negative = typeof change === "number" && change < 0;
  const t3 = positive ? "positive" : negative ? "negative" : "zero";
  let t4;
  if ($[7] !== className || $[8] !== t3) {
    t4 = classNames(statChangeVariants({
      variant: t3
    }), className);
    $[7] = className;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = positive && showPositiveSign && display === "percent" ? "+" : undefined;
  let t6;
  if ($[10] !== Comp || $[11] !== change || $[12] !== display || $[13] !== rest || $[14] !== t4 || $[15] !== t5) {
    t6 = <Comp bounded={false} className={t4} display={display} prefix={t5} value={change} {...rest} />;
    $[10] = Comp;
    $[11] = change;
    $[12] = display;
    $[13] = rest;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}
const statChangeCalloutVariants = tv({
  base: "font-medium",
  variants: {
    variant: {
      zero: "",
      positive: "",
      negative: ""
    },
    animated: {
      true: "transition-[background-color] duration-300",
      false: ""
    },
    withBackground: {
      true: "",
      false: ""
    }
  },
  compoundVariants: [{
    withBackground: true,
    className: "overflow-hidden rounded-full px-2 py-0.5"
  }, {
    withBackground: true,
    variant: "zero",
    className: "bg-bg-additional-1-transparent"
  }, {
    withBackground: true,
    variant: "positive",
    className: "bg-success-1-transparent-1"
  }, {
    withBackground: true,
    variant: "negative",
    className: "bg-error-1-transparent-1"
  }, {
    variant: ["positive", "negative"],
    className: "gap-1.5"
  }]
});
const statChangeCalloutIconVariants = tv({
  variants: {
    variant: {
      zero: "opacity-0",
      positive: "fill-success-1",
      negative: "rotate-180 fill-error-1"
    },
    animated: {
      true: "transition-[fill,transform,opacity,margin-left,margin-right] duration-500 ease-out-quint",
      false: ""
    },
    placement: {
      start: "",
      end: ""
    }
  },
  compoundVariants: [{
    variant: "zero",
    placement: "start",
    className: "-translate-x-full ml-[-9px]"
  }, {
    variant: "zero",
    placement: "end",
    className: "mr-[-9px] translate-x-full"
  }]
});
export function StatChangeCallout(t0) {
  const $ = _c(23);
  let animated;
  let change;
  let className;
  let overrides;
  let rest;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      animated,
      overrides,
      change,
      iconPlacement: t1,
      withBackground: t2,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = animated;
    $[2] = change;
    $[3] = className;
    $[4] = overrides;
    $[5] = rest;
    $[6] = t1;
    $[7] = t2;
  } else {
    animated = $[1];
    change = $[2];
    className = $[3];
    overrides = $[4];
    rest = $[5];
    t1 = $[6];
    t2 = $[7];
  }
  const iconPlacement = t1 === undefined ? "start" : t1;
  const withBackground = t2 === undefined ? true : t2;
  const positive = typeof change === "number" && change > 0;
  const negative = typeof change === "number" && change < 0;
  const variant = positive ? "positive" : negative ? "negative" : "zero";
  let t3;
  if ($[8] !== animated || $[9] !== className || $[10] !== variant || $[11] !== withBackground) {
    t3 = classNames(statChangeCalloutVariants({
      variant,
      animated,
      withBackground
    }), className);
    $[8] = animated;
    $[9] = className;
    $[10] = variant;
    $[11] = withBackground;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== animated || $[14] !== change || $[15] !== iconPlacement || $[16] !== overrides?.StatChange || $[17] !== variant) {
    t4 = iconPlacement === "start" ? <><ArrowUp className={statChangeCalloutIconVariants({
        variant,
        animated,
        placement: iconPlacement
      })} size={9} /><StatChange animated={animated} change={change} showPositiveSign={false} {...overrides?.StatChange} /></> : <><StatChange animated={animated} change={change} showPositiveSign={false} {...overrides?.StatChange} /><ArrowUp className={statChangeCalloutIconVariants({
        variant,
        animated,
        placement: iconPlacement
      })} size={9} /></>;
    $[13] = animated;
    $[14] = change;
    $[15] = iconPlacement;
    $[16] = overrides?.StatChange;
    $[17] = variant;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== rest || $[20] !== t3 || $[21] !== t4) {
    t5 = <FlexCenter className={t3} data-testid="currency-price-change" {...rest}>{t4}</FlexCenter>;
    $[19] = rest;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  return t5;
}